<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-mt-2">
                <DataTable :value="areas" :lazy="true" :paginator="true" :rows="30" :totalRecords="totalRecords"
                    :loading="loading" @page="onPage($event)" class="p-datatable-users" dataKey="mbz1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h5 class="p-m-0">Areas</h5>
                        </template>
                        <template v-slot:right>
                            <Button label="Add Area" icon="pi pi-plus" @click="toAddAreas" />
                            <Button label="Filter" icon="pi pi-filter" @click="filterlisting()" 
                                class="p-mr-2" style="margin-left: 0.5rem; "></Button>
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column headerStyle="width: 2%" class="align-center"></Column>
                    <Column field="id" header="Sr." headerStyle="width: 10%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="City" field="mal3" class="p-text-capitalize" headerStyle="width: 25%">
                    </Column>
                    <Column header="Area" field="mam3" class="p-text-capitalize" headerStyle="width: 25%">
                    </Column>
                    <Column header="Pincode" field="mam4" lass="p-text-capitalize" headerStyle="width: 25%">
                    </Column>
                    <Column header="Status" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span v-if="data.mam5 == 1" :class="'user-badge status-active'">Active</span>
                            <span v-if="data.mam5 == 0" :class="'user-badge status-temp-suspend'">Inactive</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                @click="editAreasModalOpen(data)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <!-- Add Role Dialog starts here -->
    <Dialog v-model:visible="isAddReport" :style="{ width: '800px' }" :modal="true" class="p-fluid"
        header="Add Area">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="city">
                            City
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="city" v-model="city" :options="cityList" optionLabel="label"
                            placeholder="Select ..." appendTo="body" :filter="true"></Dropdown>
                        <small class="p-invalid p-error" v-if="v$.city.$error">{{ v$.city.$errors[0].$message }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="reportreason">
                            Area
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="reportreason" v-model="reportreason" :disabled="!city" required="true" maxlength="100" placeholder="Enter city" 
                            :class="{ 'p-invalid': isSubmitted && !reportreason }" />
                        <small class="p-invalid p-error" v-if="v$.reportreason.$error">{{
                            v$.reportreason.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="pincode"> Pincode </label>
                        <InputText id="pincode" v-model="pincode" required="true" maxlength="6" placeholder="Enter pincode" 
                         />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :disabled="!isEditUserRole"
                            :options="adminstatusList" optionLabel="label" placeholder="Select ..." appendTo="body">
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="addAreas" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Add Role Dialog ends here -->

    <!-- Edit Role Dialog starts here -->
    <Dialog v-model:visible="isEditUserRole" header="Edit Area" :style="{ width: '800px' }" :modal="true"
        class="p-fluid">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="city">
                            City
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="city" v-model="city" :disabled="isEditUserRole" :options="cityList" optionLabel="label"
                            placeholder="Select ..." appendTo="body" :Object="true" :filter="true"></Dropdown>
                        <small class="p-invalid p-error" v-if="v$.city.$error">{{ v$.city.$errors[0].$message }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="reportreason">
                            Area
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="reportreason" v-model="reportreason" required="true" maxlength="100" placeholder="Enter city" 
                            :class="{ 'p-invalid': isSubmitted && !reportreason }" />
                        <small class="p-invalid p-error" v-if="v$.reportreason.$error">{{
                            v$.reportreason.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="pincode"> Pincode </label>
                        <InputText id="pincode" v-model="pincode" required="true" maxlength="6" placeholder="Enter pincode" 
                         />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus"
                            :options="adminstatusList" optionLabel="label" placeholder="Select ..." appendTo="body">
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="editAreas(rowData)" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Edit Role Dialog ends here -->
    <!-- Filter dialog start here -->
    <Dialog v-model:visible="isFilter" :style="{ width: '600px' }" header="Area Filter" :modal="true"
        class="p-fluid">
        <div class="p-pt-2 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-6">
                    <label for="areafilter"> Area</label>
                    <Dropdown id="areafilter" v-model="areaFilter" :options="areaFilterList" optionLabel="label"
                    placeholder="Select ..." appendTo="body" :filter="true"></Dropdown>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Status</label>
                    <Dropdown id="adminstatus" v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                        placeholder="Select ..." appendTo="body">
                    </Dropdown>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Reset" icon="pi pi-refresh" class="p-button-text" @click="reSetFilteredData()" />
            <Button label="Search" icon="pi pi-search" class="p-mr-2" autofocus @click="submitFilter" />
        </template>
    </Dialog>
    <!-- Filter dialog end here -->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useConfirm } from "primevue/useconfirm";
import { required, helpers } from '@vuelidate/validators';

export default {
    data() {
        return {
            confirm: useConfirm(),
            areas: [],
            v$: useValidate(),
            isAddReport: false,
            isSubmitted: false,
            showLoader: false,
            loading: false,
            page_no: 0,
            totalRecords: 0,
            isEditUserRole: false,
            showLoaderAddBtn: false,
            rowId: '',
            reportreason: '',
            countries: [],
            city: '',
            country: '',
            pincode: '',
            cityList: [],
            adminstatus: { label: 'Active', value: 1 },
            adminstatusList: [
                { label: 'Active', value: 1 },
                { label: 'Inactive', value: 0 },
            ],
            isFilter: false,
            areaFilter: '',
            areaFilterList : [],
        };
    },
    validations() {
        return {
            reportreason: { required: helpers.withMessage('Please enter city', required) },
            adminstatus: { required: helpers.withMessage('Please select admin status', required) },
            city: { required: helpers.withMessage('Please select state', required) },
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        this.loading = true;
        this.getAllAreas({ page_no: this.page_no });
        this.getCities();
    },
    methods: {
        getCities () {
            this.ApiService.getCities({ mak2: this.country.value } ).then((items) => {
                if (items.status === 200) {
                    this.cityList = items.data;
                }
            })
        },
        getAllAreas(e) {
            e.page_no = this.page_no;
            this.ApiService.getAllAreas(e).then((items) => {
                if (items.status === 200) {
                    this.areas = items.data;
                    this.totalRecords = items.count;
                    this.isFilter = false;
                } else {
                    this.areas = [];
                }
                this.loading = false;
            });
        },
        async toAddAreas() {
            this.isAddReport = true;
            this.isSubmitted = false;
            this.reportreason = '';
            this.city = '';
            this.pincode = '';
            this.country = '';
            this.adminstatus = { label: 'Active', value: 1 };
            this.v$.$reset();
        },
        addAreas() {
            this.submitted = true;
            this.errormsg = '';
            this.v$.$validate();
            let formData = new FormData();
            formData.append('mam2', this.city.value);
            formData.append('mam3', this.reportreason);
            formData.append('mam4', this.pincode);
            formData.append('mam5', this.adminstatus.value);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateAreas(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getAllAreas({ page_no: this.page_no });
                        this.isAddReport = false;
                        this.reportreason = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        editAreasModalOpen(data) {
            this.isEditUserRole = true;
            this.reportreason = '';
            this.country = '';
            this.city = '';
            this.adminstatus = '',
            this.rowId = data.mam1;
            this.reportreason = data.mam3;
            this.pincode = data.mam4;
            this.city = this.cityList.find((item) => item.value == data.mal1);
            this.adminstatus = this.adminstatusList.find((item) => item.value == data.mam5);
        },
        editAreas() {
            this.submitted = true;
            this.errormsg = '';
            let formData = new FormData();
            formData.append('mam1', this.rowId);
            formData.append('mam2', this.city?.value);
            formData.append('mam3', this.reportreason);
            formData.append('mam4', this.pincode);
            formData.append('mam5', this.adminstatus?.value);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateAreas(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getAllAreas({ page_no: this.page_no });
                        this.isEditUserRole = false;
                        this.reportreason = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getAllAreas({ page_no: event.page });
        },
        getAreaList() {
            this.ApiService.getAreaList().then((items) => {
                if (items.status === 200) {
                    this.areaFilterList = items.data;
                }
            })
        },
        reSetFilteredData() {
            this.getAllAreas({ page_no: this.page_no });
            this.isFilter = false;
            this.areaFilter = '';
            this.adminstatus = '';
            // this.showFillFilter = false;
        },
        filterlisting() {
            this.isFilter = true;
            this.adminstatus = { label: 'Active', value: 1 };
            this.getAreaList();
        },
        submitFilter() {
            this.showFillFilter = true;
            this.getAllAreas({ mam3: this.areaFilter.label, mam5: this.adminstatus.value });
        },
    }
};
</script>